import { render, staticRenderFns } from "./SaleTaxGroupInputs.vue?vue&type=template&id=2a5a9634&"
import script from "./SaleTaxGroupInputs.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports